let inject = ['$q','$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];
class TemplateDetailService {
  constructor ($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
    this.$q = $q;
    this.$http = $http;
    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
    this.ngAuthSettings = ngAuthSettings;
    this.AuthTokenFactory = AuthTokenFactory;
    this.SharedService = SharedService;
    this.SessionService = SessionService;
  }
  
  getUserCartTemplate(data) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getUserCartTemplate,
        cache : false,
        data : this.$httpParamSerializerJQLike(data),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      }).then(response => {
        resolve(response.data);
      }).catch(reason => {
        reject(reason);
      });
    });
  }


}

TemplateDetailService.$inject = inject;

export default TemplateDetailService;



// WEBPACK FOOTER //
// ./www/components/templates/template-detail/template-detail.service.js